module.exports = __webpack_public_path__ + "static/media/peijianxiaoshou1.e26a5aa8.png";